import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";

// Public fullscreen QR page. The customer opens this from their WhatsApp link
// and shows the QR to the cashier. Scanning opens WhatsApp with REDEEM <code>.

export function Redeem() {
  const { code } = useParams();
  const [svg, setSvg] = useState<string | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!code) return;
    fetch(`/qr/${encodeURIComponent(code)}`)
      .then((r) => (r.ok ? r.text() : Promise.reject(r.statusText)))
      .then(setSvg)
      .catch((e) => setErr(String(e)));
  }, [code]);

  return (
    <div className="min-h-screen w-full bg-neutral-900 text-white flex flex-col items-center justify-center px-6 py-8">
      <div className="text-xs uppercase tracking-widest text-neutral-400">Punchy redemption</div>
      <div className="mt-6 bg-white rounded-xl p-4 shadow-xl">
        {err && <div className="w-72 h-72 flex items-center justify-center text-red-600">{err}</div>}
        {!svg && !err && <div className="w-72 h-72 flex items-center justify-center text-neutral-400">…</div>}
        {svg && (
          <div
            ref={containerRef}
            className="w-72 h-72"
            dangerouslySetInnerHTML={{ __html: svg }}
          />
        )}
      </div>
      <div className="mt-8 text-4xl font-mono tracking-[0.3em]">{(code ?? "").toUpperCase()}</div>
      <div className="mt-4 text-sm text-neutral-400 text-center max-w-xs">
        Show this to the cashier. They'll scan, confirm, and you're done.
      </div>
    </div>
  );
}
